import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Loader, Input, Dropdown, TextArea, Checkbox, Button, Form} from 'semantic-ui-react';
import {transportTypes} from '../../../common/dictionaries/classification';
import {parseReasons} from '../../../common/util/options';
import {Actions} from '../../../common/actions';

class InputSection extends Component {
  renderChassis() {
    const {reason} = this.props.data;
    if (reason === 'LB') {
      return (<Grid.Column width='10' />);
    }
    return (
      <React.Fragment>
        <Grid.Column width='2' verticalAlign='middle'>
          <label><strong>VIN</strong></label>
        </Grid.Column>
        <Grid.Column width='4'>
          <Input fluid
            name='chassis'
            placeholder='Ingrese el VIN (chasis)'
            maxLength='17'
            error={!this.props.data.chassis}
            value={this.props.data.chassis}
            onChange={this.props.handleParameterChange}
            onKeyDown={(e) => {
              if (e.key === 'Tab') {
                if (this.props.data.chassis.length !== 17) {
                  this.props.addMessageBoxError('La longitud del campo Vin debe ser de 17 caracteres');
                  return;
                }
                e.preventDefault(); // Evita el comportamiento por defecto si es necesario
                this.props.getVehicleInf(this.props.data.chassis); // Llama a la función que manejará la acción
              }
            }
            }
          />
        </Grid.Column>
        <Grid.Column verticalAlign='middle'>
          <label><strong>Vehículo</strong></label>
        </Grid.Column>
        <Grid.Column width='4' verticalAlign='middle'>
          <label> {this.props.vehicleInf.modelName} </label>
        </Grid.Column>
        <Grid.Column verticalAlign='middle'>
          <label><strong>Origen</strong></label>
        </Grid.Column>
        <Grid.Column width='4' verticalAlign='middle'>
          <label> {this.props.vehicleInf.origen} </label>
        </Grid.Column>
      </React.Fragment>
    );
  }

  renderWarrantyInfo() {
    const {transport} = this.props.data;
    if (transport === 'x') {
      return (<Grid.Column width='10' />);
    }
    return (
      <React.Fragment>
        <Grid.Row>
          <Grid.Column width='4' verticalAlign='middle'>
            <label><strong>Garantía</strong></label>
          </Grid.Column>
          <Grid.Column width='2' verticalAlign='middle'>
            <Checkbox toggle
              name='warranty'
              checked={this.props.data.warranty}
              onChange={this.props.handleWarrantyChange}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          {this.renderChassis()}
        </Grid.Row>
      </React.Fragment>
    );
  }
  renderStopVehInfo() {
    const {reason} = this.props.data;
    if (reason === 'LB') {
      return (<Grid.Column width='10' />);
    }
    return (
      <Grid.Row>
        <Grid.Column width='4' verticalAlign='middle'>
          <label><strong>Vehículo Inmovilizado</strong></label>
        </Grid.Column>
        <Grid.Column width='2' verticalAlign='middle'>
          <Checkbox toggle
            name='stopVeh'
            checked={this.props.data.stopVeh}
            onChange={this.props.handleWarrantyChange}
          />
        </Grid.Column>
      </Grid.Row>
    );
  }
  renderNewVehInfo() {
    const {reason} = this.props.data;
    if (reason === 'LB') {
      return (<Grid.Column width='10' />);
    }
    return (
      <Grid.Row>
        <Grid.Column width='4' verticalAlign='middle'>
          <label><strong>Vehículo Nuevo</strong></label>
        </Grid.Column>
        <Grid.Column width='2' verticalAlign='middle'>
          <Checkbox toggle
            name='newVeh'
            checked={this.props.data.newVeh}
            onChange={this.props.handleWarrantyChange}
          />
        </Grid.Column>
      </Grid.Row>
    );
  }

  render() {
    const {loading, loadingReasons, reasons} = this.props;

    if (loading) {
      return (
        <Grid.Row>
          <Grid.Column width='16'>
            <Loader active inline='centered'>Procesando...</Loader>
          </Grid.Column>
        </Grid.Row>
      );
    }

    return (
      <Grid.Row>
        <Grid.Column width='8'>
          <Grid className='order-parameters'>
            <Grid.Row>
              <Grid.Column width='4' verticalAlign='middle'>
                <label><strong>Razón</strong></label>
              </Grid.Column>
              <Grid.Column width='12'>
                <Dropdown fluid selection
                  name='reason'
                  placeholder='Seleccione una razón'
                  disabled={loadingReasons}
                  options={parseReasons(reasons)}
                  error={!this.props.data.reason}
                  value={this.props.data.reason}
                  onChange={this.props.handleReasonChange}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width='4' verticalAlign='middle'>
                <label><strong>Vía</strong></label>
              </Grid.Column>
              <Grid.Column width='12'>
                <Dropdown fluid selection
                  name='transport'
                  placeholder='Seleccione una vía de transporte'
                  options={transportTypes}
                  error={!this.props.data.transport}
                  value={this.props.data.transport}
                  onChange={this.props.handleParameterChange}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width='4' verticalAlign='middle'>
                <label><strong>Código</strong></label>
              </Grid.Column>
              <Grid.Column width='12'>
                <Input fluid
                  name='partCode'
                  placeholder='Ingrese el código'
                  maxLength='20'
                  error={!this.props.data.partCode}
                  value={this.props.data.partCode}
                  onChange={this.props.handlePartCodeChange}/>

              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width='4' verticalAlign='middle'>
                <label><strong>Cantidad</strong></label>
              </Grid.Column>
              <Grid.Column width='12'>
                <Input fluid required
                  name='partQuantity'
                  type='number'
                  placeholder='Ingrese la cantidad'
                  min={1}
                  max={9999}
                  error={!this.props.data.partQuantity}
                  value={this.props.data.partQuantity}
                  onChange={this.props.handleQuantityChange}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
            </Grid.Row>
            {this.renderWarrantyInfo()}
            {this.renderStopVehInfo()}
            {this.renderNewVehInfo()}
          </Grid>
        </Grid.Column>
        <Grid.Column width='8'>
          <Grid className='order-parameters'>
            <Grid.Row>
              <Grid.Column width='4' verticalAlign='middle'>
                <label><strong>Orden de Reparación</strong></label>
              </Grid.Column>
              <Grid.Column width='12'>
                <Input fluid
                  name='orderRepair'
                  type='text'
                  placeholder='Ingrese la orden de reparación'
                  value={this.props.data.orderRepair}
                  onChange={this.props.handlePartCodeChange}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row className='order-comment'>
              <Grid.Column width='4'>
                <label><strong>Comentario</strong></label>
              </Grid.Column>
              <Grid.Column width='12'>
                <Form>
                  <TextArea
                    name='comment'
                    placeholder='Comentario (opcional)'
                    maxLength='300'
                    value={this.props.data.comment}
                    class={this.props.data.comentNecesary ? 'quantityValidate' : ''}
                    onChange={this.props.handleParameterChange}
                  />
                </Form>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column className='order-placeholder' />
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width='16' textAlign='right'>
                <Button primary
                  type='button'
                  content='AGREGAR'
                  onClick={this.props.handleAddClick}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Column>
      </Grid.Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.dealerSpecialOrders.loading,
    'loadingReasons': state.dealerSpecialOrders.loadingReasons,
    'reasons': state.dealerSpecialOrders.orderReasons,
    'dealer': state.session.dealerId,
    'agency': state.session.dealerAgency,
    'orderDetail': state.dealerSpecialOrders.list,
    'vehicleInf': state.dealerSpecialOrders.vehicleInf,
  };
};

const {
  addMessageBoxError,
  checkDealerSpecialOrderElement,
  getVehicleInf,
} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxError,
  checkDealerSpecialOrderElement,
  getVehicleInf,
})(InputSection);
